// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XNjO","largestCol":"styles_largestCol__1CdDQ","smallestCol":"styles_smallestCol__3mmo9"};